import { getAgentsWithCreator } from "web_myplann/Activities/Helpers/getAgentsWithCreator";
import { useActivityParticipantGroups } from "web_myplann/Activities/Hooks/useActivityParticipantGroups";
import { useActivityAgentsQuery } from "web_myplann/Api/Activities/useActivityAgentsQuery";
import { useActivityNotesQuery } from "web_myplann/Api/Activities/useActivityNotesQuery";
import { useActivityParticipantsQuery } from "web_myplann/Api/Activities/useActivityParticipantsQuery";
import { useActivityQuery } from "web_myplann/Api/Activities/useActivityQuery";
import { useAgentQuery } from "web_myplann/Api/Advisor/useAgentQuery";
import { useAssignedAgentsQuery } from "web_myplann/Api/Advisor/useAssignedAgentsQuery";
import { UserAgentStatusEnum } from "web_myplann/Infrastructure/Api/Api";

export const useActivityDetail = (activityId: number | null) => {
	const { data: dataEvent, isLoading: isLoadingEvent } =
		useActivityQuery(activityId);
	const { data: dataAgents, isLoading: isLoadingAgents } =
		useActivityAgentsQuery(activityId);
	const { data: dataNotes, isLoading: isLoadingNotes } =
		useActivityNotesQuery(activityId);
	const { data: dataParticipants, isLoading: isLoadingParticipants } =
		useActivityParticipantsQuery(activityId);

	const { data: agentDetail } = useAgentQuery(dataEvent?.author?.id);
	const { data: assignedAgents } = useAssignedAgentsQuery(
		UserAgentStatusEnum.Connected,
	);

	const agents = getAgentsWithCreator(
		dataAgents?.data ?? [],
		dataEvent?.creator,
	);
	const participantGroups = useActivityParticipantGroups(
		dataParticipants?.data ?? [],
		agents,
	);

	const isLoading =
		isLoadingEvent ||
		isLoadingNotes ||
		isLoadingParticipants ||
		isLoadingAgents;

	return {
		event: dataEvent ?? undefined,
		notes: dataNotes?.data ?? [],
		participantGroups,
		hasMoreAgents: (assignedAgents?.data.length ?? 0) > 1,
		isLoading,
		isNotFound: dataEvent === null,
		contactPhone: agentDetail?.phone ?? undefined,
		contactEmail: agentDetail?.email ?? undefined,
	};
};
